'use client';
import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { z } from 'zod';

import { CompanyProps } from './company';

import { Button, Input } from '@components/Form';
import { toastError, toastSuccess } from '@components/root/NotificationProxy';
import { logger } from '@logger';
import { useUserStore } from '@utils/user';

const schema = z.object({
  companyName: z.string().max(35),
  positionName: z.string().max(35),
});

export default function Info({ labels, user }: CompanyProps) {
  const [isLoading, setLoading] = useState<boolean>(false);
  const userStore = useUserStore();

  const {
    handleSubmit,
    register,
    formState: { errors },
    setValue,
  } = useForm({
    resolver: zodResolver(schema),
    defaultValues: {
      companyName: user?.companyName,
      positionName: user?.positionName,
    },
  });

  useEffect(() => {
    setValue('companyName', user?.companyName);
    setValue('positionName', user?.positionName);
  }, [user]);

  const formSubmit = handleSubmit(async (formData: any) => {
    setLoading(true);
    try {
      await fetch(`${process.env.NEXT_PUBLIC_API_PUBLIC}/users/profile/edit`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${userStore.accessToken}`,
        },
        body: JSON.stringify({
          ...formData,
        }),
      });
      toastSuccess(labels.toast.success);
    } catch (e) {
      logger.error(e, 'Profile edit %s', (e as any)?.message);
      toastError(labels.toast.error);
    } finally {
      setLoading(false);
    }
  });
  return (
    <form onSubmit={formSubmit}>
      <label htmlFor="companyName">
        {labels.companyName}
        <Input error={!!errors.companyName} {...register('companyName')} />
      </label>
      <label htmlFor="positionName">
        {labels.positionName}
        <Input error={!!errors.positionName} {...register('positionName')} />
      </label>
      {user?.transId && (
        <div>
          Trans-id: <span className="font-weight-bold">{user?.transId}</span>
        </div>
      )}
      <Button className="mt-5" loading={isLoading}>
        {labels.save}
      </Button>
    </form>
  );
}
